'use client';

import { useState } from 'react';

import { useTranslations } from '@fshr/context/i18n-context';
import { Button, Checkbox, Icon } from '@fshr/components';
import { cn } from '@fshr/shared-react';

interface PersistUserCheckboxProps {
	isChecked: boolean;
	onChange: (value: boolean) => void;
}

export default function PersistUserCheckbox({ isChecked, onChange }: PersistUserCheckboxProps) {
	const t = useTranslations();
	const [showDetails, setShowDetails] = useState(false);
	return (
		<div className="flex flex-col gap-100">
			<div className="flex items-center justify-center gap-100">
				<Checkbox
					checked={isChecked}
					onChange={value => onChange(Boolean(value))}
					label={t('Keep me signed in')}
					labelClassName="text-label pt-[5px]"
					wrapperClassName="gap-100"
				/>
				<div className="flex items-center gap-[5px]">
					<Button intent="text" onClick={() => setShowDetails(!showDetails)}>
						{t('Details')}
					</Button>
					<Icon
						icon="collapse"
						className={cn('text-[5px]', {
							'rotate-180': !showDetails,
						})}
					/>
				</div>
			</div>
			{showDetails && (
				<div className="bg-surface-recessed px-150 py-100 max-w-[435px] border-border-subtle">
					<p className="text-caption">
						{t(
							'This option will reduce the frequency of being asked to sign-in on this device. Use this option only on your trusted devices to keep your account secure.'
						)}
					</p>
				</div>
			)}
		</div>
	);
}
